import { helpers } from '../helpers.js';

/**
 * @description product slider for displaying many products in a limited space. It is navigarable by clicking on the arrows or by swiping on mobile devices.
 *
 * TODO: - describe requirements, - generalize if there is a usecase for a slider for any kind of content
 */
export class ProductSlider {
    static initAuto() {
        /*console.debug("[ProductSlider] initAuto")*/
        document.querySelectorAll('.product-slider').forEach((slider) => {
            this.init(slider);
        })
        return this;
    }

    static init(slider) {
        /*console.debug("[ProductSlider] init")*/
        if (slider.dataset.initialized) return;
        slider.dataset.initialized = true;
        slider.classList.add('product-slider--initialized');

        this.setDataAttributes(slider);
        // this.cloneItems(slider); // ?infini-scroll?
        this.attatchClickListeners(slider);
        this.attatchSwipeListeners(slider);
        this.attatchResizeListeners(slider);
        this.updateClasses(slider);
        this.updatePosition(slider);
        return this;
    }

    // INIT

    static setDataAttributes(slider) {
        /*console.debug("[ProductSlider] setDataAttributes")*/
        const items = slider.querySelector(".product-slider__items")
        if (!items) return
        const wrapperWidthPx = items.parentElement.offsetWidth
        const itemsCount = items.childElementCount
        const itemsWidthPx = items.offsetWidth
        const itemWidthPx = items.children[0].offsetWidth
        const itemMarginPx = (itemsWidthPx - (itemWidthPx * itemsCount)) / (itemsCount - 1)
        const stepOffset = itemWidthPx + itemMarginPx
        const itemsVisibleCount = Math.floor(wrapperWidthPx / stepOffset)

        console.debug("[ProductSlider] setDataAttributes", {
            wrapperWidthPx,
            itemsCount,
            itemsVisibleCount,
            itemsWidthPx,
            itemWidthPx,
            itemMarginPx,
            stepOffset
        })

        // slider.style.setProperty('--width-item', `${itemWidthPx}px`)
        slider.dataset.lastIndex = itemsCount - itemsVisibleCount
        slider.dataset.offsetStep = stepOffset
        if (slider.dataset.index === undefined) {
            slider.dataset.index = 0
        }
    }


    static attatchClickListeners(slider) {
        /*console.debug("[ProductSlider] attatchListeners")*/
        const nav = slider.querySelectorAll('.product-slider__nav-action');
        nav.forEach(elNavAction => {
            /*console.debug("[ProductSlider] elNavAction:", elNavAction)*/
            elNavAction.addEventListener('click', (e) => {
                const action = e.target.dataset.action;
                /*console.debug("[ProductSlider] product-slider__action:", action)*/
                if (action === 'prev') {
                    this.moveToPrev(slider);
                } else if (action === 'next') {
                    this.moveToNext(slider);
                }
                this.updateClasses(slider);
                this.updatePosition(slider);
            });
        });
    }

    static attatchSwipeListeners(slider) {
        /*console.debug("[ProductSlider] attachSwipeListeners")*/
        helpers.swipe.addCallback(slider, {
            left: () => { this.moveToNext(slider); this.updateClasses(slider); this.updatePosition(slider); },
            right: () => { this.moveToPrev(slider); this.updateClasses(slider); this.updatePosition(slider); }
        });
    }

    static attatchResizeListeners(slider) {
        /*console.debug("[ProductSlider] attatchResizeListeners")*/
        window.addEventListener('resize', () => {
            this.setDataAttributes(slider);
            this.updatePosition(slider);
        });
    }

    // ACTIONS
    static moveToPrev(slider) {
        /*console.debug("[ProductSlider] moveToPrev")*/
        const index = parseInt(slider.dataset.index)
        const lastIndex = parseInt(slider.dataset.lastIndex)
        if (isNaN(lastIndex)) return
        if (isNaN(index)) return
        /*console.debug("[ProductSlider] moveToPrev")*/
        if (index <= 0) return
        slider.dataset.index = index - 1
    }

    static moveToNext(slider) {
        /*console.debug("[ProductSlider] moveToNext")*/
        const index = parseInt(slider.dataset.index)
        const lastIndex = parseInt(slider.dataset.lastIndex)
        if (isNaN(lastIndex)) return
        if (isNaN(index)) return
        /*console.debug("[ProductSlider] moveToNext")*/
        if (index >= lastIndex) return
        slider.dataset.index = index + 1
    }

    // HELPERS
    static updateClasses(slider) {
        /*console.debug("[ProductSlider] updateClasses")*/
        const index = parseInt(slider.dataset.index)
        const lastIndex = parseInt(slider.dataset.lastIndex)
        if (isNaN(index)) return
        if (isNaN(lastIndex)) return

        if (index <= 0) {
            slider.classList.add('product-slider--first');
        } else {
            slider.classList.remove('product-slider--first');
        }
        if (index >= lastIndex) {
            slider.classList.add('product-slider--last');
        } else {
            slider.classList.remove('product-slider--last');
        }
    }

    static updatePosition(slider) {
        /*console.debug("[ProductSlider] updatePosition")*/
        const items = slider.querySelector(".product-slider__items")
        if (!items) {
            console.error("[ProductSlider] No items found")
            return
        }
        const index = parseInt(slider.dataset.index)
        if (isNaN(index)) {
            console.error("[ProductSlider] index is not a number")
            return
        }
        const offsetStep = parseInt(slider.dataset.offsetStep)
        if (isNaN(offsetStep)) {
            console.error("[ProductSlider] offsetStep is not a number")
            return
        }
        const newLeft = index * offsetStep
        $(items).animate({ left: `-${newLeft}px` }, 150, 'linear');
    }

    // static itemWidthJustify(itemWidthPx, itemMarginPx, wrapperWidthPx) {
    //         return itemWidthPx;
    // }
}
